import { Component, ViewChild} from '@angular/core';
import { WizBaseCollector, WizCheckbox, WizDropItemEvent, WizTranslationManager} from '@wizeoo/akm-component-lib';
import { WidgetConfigurationItemObj, Measure } from '@wizeoo/akm-message-lib';
import { BaselineEngine, FIELD_KIND, FeiKeyDef, WizConstants, EM_ACTION, KEY_KIND } from '@wizeoo/akm-compute-lib';

import { TIMELINE_MODE, WIDGET_KIND } from '../../../../model/enums';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { FormFieldObj } from '../../../../manager/baselines/form-field.obj';
import { PivotBasePop } from '../../pivot/renderers/settings/pivot-base.pop';
import { PivotEditItemRenderer } from '../../pivot/renderers/settings/pivot-edit-item.renderer';
import { gridsterItemEvent } from '../../form/generic/form-widget.gridster.component';
import { ViewData } from '../../../../model/view.data';
import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { WizMathUtils } from '@wizeoo/akm-core-lib';


@Component({
  // popUp d'édition du grid en mode flat : gestion des emplacements de champs et rendu
  selector: 'timeline-settings-pop',
  templateUrl: './timeline-settings.pop.html',
})
export class TimelineSettingsPop extends PivotBasePop {
  
  @ViewChild('cbYear', { read: WizCheckbox }) cbYear: WizCheckbox; // contrôle avant update
  @ViewChild('cbTrim', { read: WizCheckbox }) cbTrim: WizCheckbox; // contrôle avant update
  @ViewChild('cbMonth', { read: WizCheckbox }) cbMonth: WizCheckbox; // contrôle avant update
  @ViewChild('cbDay', { read: WizCheckbox }) cbDay: WizCheckbox; // contrôle avant update


  public popUpMode: WIDGET_KIND = WIDGET_KIND.TIMELINE; // le mode de cette pop, pour alimenter les PKD
  public renderer: any = PivotEditItemRenderer;
  public widgets: GridsterWidgetItem[];


  /**
   * @override
   * sur séquence de démarrage, alimentation des listes avec leurs DS
   */
  public feedDatasources(): void {
    super.feedDatasources();

    // ajout du fake pour mettre un libellé
    this.dataSource.addItem(this.buildFake(ViewData.FORM_LABEL,'$.common.label.$', -3 ));
    this.dataSource.addItem(this.buildFake(ViewData.FORM_TITLE,'$.common.title.$', -2 ));
    this.dataSource.addItem(this.buildFake(ViewData.FORM_COMMENT,'$.common.comment.$', -1 ));
    
    // this.lstData.dropTransformFunction = this.pkdToPivotField.bind(this);
    this.lstData.dropControlFunction = this.dataDropControl.bind(this);
    
    this.widgets = this.context.ff?.map((wcio: WidgetConfigurationItemObj) => {
      const result: GridsterWidgetItem = new GridsterWidgetItem(wcio, new FormFieldObj(this.widget, this.fei, wcio));
      return result;
    }) || [];

    // alimentation des cbx de portée
    // recyclage de mem (massEditMode)
    let whos: number = this.context.mem;
    this.cbYear.wizChecked = WizMathUtils.wizBitwize(whos, TIMELINE_MODE.YEAR) > 0;
    this.cbTrim.wizChecked = WizMathUtils.wizBitwize(whos, TIMELINE_MODE.QUARTER) > 0;
    this.cbMonth.wizChecked = WizMathUtils.wizBitwize(whos, TIMELINE_MODE.MONTH) > 0;
    this.cbDay.wizChecked = WizMathUtils.wizBitwize(whos, TIMELINE_MODE.DAY) > 0;

  }

  /** icone de suppression globale */
  public onDeleteClick(): void {
    this.widgets = [];
  }

  onWidgetsChanged(event: gridsterItemEvent) {
    // console.log('onWidgetsChanged',event, this.widgets);
    switch(event.action) {
      case EM_ACTION.CREATE:
        this.widgets = [event.item, ...this.widgets];
        break;
      case EM_ACTION.UPDATE:
        // console.log('onWidgetsChanged rien a faire');
        event.item.updateCoords(); // mise à jour des coords
        break;
      case EM_ACTION.DELETE:
        this.widgets.splice(this.widgets.indexOf(event.item), 1);
        break;     
    }
  }

  public updateContext(): void {
    super.updateContext();
    this.context.ff = this.widgets.map(w => w.source);

    let whos: number = 0;
    if(this.cbYear.wizChecked) {
      whos += TIMELINE_MODE.YEAR;
    }
    if(this.cbTrim.wizChecked) {
      whos += TIMELINE_MODE.QUARTER;
    }
    if(this.cbMonth.wizChecked) {
      whos += TIMELINE_MODE.MONTH;
    }
    if(this.cbDay.wizChecked) {
      whos += TIMELINE_MODE.DAY;
    }
    this.context.mem = whos;

  }

  /**
   * override pour passage du resize sur les champs posés en sublist
   * @param e alkEvent, data = [pivotField, wizBaseCollector]
   */
   protected showConfPop(e: AlkEvent): void {
    
    const baseCollector: WizBaseCollector = e.data[1];
    const pivotField: PivotField = e.data[0];
    if (!!baseCollector && baseCollector.id === 'lstData') {
      pivotField.colRezisable = true;
    }
    super.showConfPop(e);
  }

  /**
   * construction des fakes pour gérer libellé, titre et comment
   * @param code 
   * @param label 
   * @param order 
   * @returns 
   */
  private buildFake(code: string, label: string, order: number): PivotField {
    // construction d'un fake de mesure pour alimenter le pivotField
    let fakeMeas: Measure = new Measure();
    fakeMeas.code = code;
    fakeMeas.shortCode = code;
    fakeMeas.mode = WizConstants.MEASURE_MODE_INTERACT;
    // let fakeMeasVO: MeasureVO = new MeasureVO(fakeMeas);
    
    let fakeLabel: FeiKeyDef = BaselineEngine.buildFeiKeyDef(this.fei, KEY_KIND.MEASURE,fakeMeas);
    fakeLabel.label =  WizTranslationManager.getInstance().translateKey(label);
    fakeLabel.order = order;

    let fakePivot: PivotField = new PivotField(this.widget, null, fakeLabel, null);

    return fakePivot;
  }

  /* ##############################################################################
                   contrôles de cohérence du drag'n'drop
     ############################################################################## */

  /** Fonction de controle du drop sur les clés d'aggregat : unicité sur row/column */
  public dataDropControl({ item, dragSource }: WizDropItemEvent): boolean {
    let fkd: FeiKeyDef;
    

    let field: PivotField = item.data as PivotField;
    fkd = field.fkd;
     
    let result: boolean = true;
    if (fkd.datakind !== FIELD_KIND.DATE && fkd.datakind !== FIELD_KIND.WORKFLOW) {
      // uniquement les mesures de type date
      result = false;
    }

    return result;
  }



}
